import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ArquivosComponent } from './arquivos/arquivos.component';
import { LogChannelsComponent } from './log-channels/log-channels.component';
import { LogStatsPanelComponent } from './log-channels/log-stats-panel.component';
import { InjectionMap2dComponent } from './log-channels/injection-map-2d.component';
import { InjectionMap3dComponent } from './log-channels/injection-map-3d.component';
import { TranslocoRootModule } from 'src/app/transloco-root.module';
import { ButtonModule } from 'primeng/button';
import { VcuModule } from '../vcu/vcu.module';
import { DashboardTemplateComponent } from "./dashboard-template/dashboard-template.component";
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { RegisterModule } from '../register/register.module';
import { AccordionModule } from 'primeng/accordion';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { CardModule } from '../card/card.module';
import { Title } from '@angular/platform-browser';
import { CarouselModule } from 'primeng/carousel';
import { SkeletonModule } from 'primeng/skeleton';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ColorPickerModule } from 'primeng/colorpicker';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TruncNumberPipe } from 'src/app/share/pipes/trunc-number.pipe';


@NgModule({
  declarations: [
    DashboardComponent,
    ArquivosComponent,
    LogChannelsComponent,
  ],
  imports: [
    CommonModule,
    ButtonModule,
    TranslocoRootModule,
    VcuModule,
    CardModule,
    RegisterModule,
    DashboardTemplateComponent,
    AccordionModule,
    InputIconModule,
    IconFieldModule,
    ReactiveFormsModule,
    FormsModule,
    InputTextModule,
    ProgressSpinnerModule,
    DialogModule,
    ToastModule,
    CarouselModule,
    SkeletonModule,
    ConfirmDialogModule,
    RadioButtonModule,
    CheckboxModule,
    TooltipModule,
    ColorPickerModule,
    SelectButtonModule,
    DragDropModule,
    InjectionMap2dComponent,
    InjectionMap3dComponent,
    LogStatsPanelComponent,
    TruncNumberPipe,
  ],
  exports: [
  ],
  providers: [provideAnimations(), provideAnimationsAsync(), Title]
})
export class DashboardModule { }
